import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import { Action } from '../../components/Reposit/RepositSummary/styles';
import { Header3, P2 } from '../../components/Typography';
import { revokeOrganizationUserRolesRequested } from '../../redux/organization-user/organization-user.actions';

interface RevokeRolesModalProps {
  onDismiss: () => void;
  userId: string;
  organizationId: string;
}

export const RevokeRolesModal: React.FC<RevokeRolesModalProps> = ({ onDismiss, userId, organizationId }) => {
  const dispatch = useDispatch();
  const onSubmit = () => {
    dispatch(revokeOrganizationUserRolesRequested({ userId, organizationId }));
    onDismiss();
  };
  return (
    <Modal onDismiss={onDismiss}>
      <Header3 style={{ marginBottom: 6 }}>Revoke Admin Roles</Header3>
      <P2>
        Are you sure you want to revoke admin roles from this user? They will no longer be able to handle onboarding, or manage
        users, bank accounts or recipients.
      </P2>
      <Action style={{ marginTop: 16, justifyContent: 'flex-end', display: 'flex', flexDirection: 'row', columnGap: '10px' }}>
        <Button buttonType="secondary" noArrow={true} onClick={onDismiss}>
          Cancel
        </Button>
        <Button onClick={onSubmit}>Confirm</Button>
      </Action>
    </Modal>
  );
};
